/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const hetcomite: CommunityData = {
  code: "hetcomite",
  inviteCode: "hetcomite",
  name: "Het Comité",
  defaultCurrency: "EUR",
  thumbnail: "/assets/customizations/hetcomite/hetcomite-thumbnail.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/hetcomite`,
  socials: {},
  styles: {
    global: {
      counterColor: "#232734",
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      logo: {
        src: "/assets/customizations/hetcomite/logo.png",
        styles: "w-[160px] !bottom-5",
      },
      bgDesktop: "/assets/customizations/hetcomite/hetcomite-bg.png",
      bgMobile: "/assets/customizations/hetcomite/hetcomite-bg.png",
      contentBoxShadow: "border-[1px]",
      bgColor: "#1A2720",
      asideBg: "#ffffff",
      asideStyles: "",
      contentBg: "#ffffff",
      mainFont: "font-['NeueHaasDisplay-Regular']",
      primaryButton:
        "bg-[#000000] px-6 py-4 font-['NeueHaasDisplay-Medium'] text-white text-[16px] rounded-[100px] uppercase",
    },
    navigation: {
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      iconsColor: "#232734",
      separator: "border-black border-t",
      item: "text-[18px] leading-[18px] h-[40px] flex justify-center items-center font-['NeueHaasDisplay-Regular'] !pl-0 uppercase letter-spacing-[-0.5px]",
      itemSelected: "bg-[#BEBEBE] bg-opacity-30",
    },
    communityLanding: {
      emptyOrLoadingState: "",
      titles:
        "font-['NeueHaasDisplay-Medium'] text-[40px] leading-[48px] uppercase tracking-[-2px] pb-2",
      container: "!space-y-0",
      announcements: {
        media: "border border-black",
        container: "",
        lg: {
          title:
            "font-['NeueHaasDisplay-Medium'] text-[32px] uppercase tracking-[-1px] text-[#FFFFFF]",
          subtitle:
            "font-['NeueHaasDisplay-Medium'] text-[12px] leading-[12px] !bg-white !text-black rounded-2xl border border-black uppercase",
        },
        sm: {
          title:
            "font-['NeueHaasDisplay-Medium'] text-[16px] uppercase tracking-[-0.5px] text-[#FFFFFF]",
          subtitle:
            "font-['NeueHaasDisplay-Medium'] text-[10px] leading-[12px] !bg-white !text-black rounded-2xl border border-black uppercase",
        },
      },
      event: {
        container: "border-b border-t border-black pt-8",
        title: "font-['NeueHaasDisplay-Medium'] text-[20px] leading-6 tracking-[-1px] uppercase",
        subtitle:
          "font-['NeueHaasDisplay-Medium'] text-[12px] leading-[12px] !bg-white !text-black uppercase",
        media: "border border-black aspect-square",
      },
      shop: {
        container: "pt-8",
        title: "mt-6 font-['NeueHaasDisplay-Medium'] text-[32px] tracking-[-2px] uppercase",
        text: "font-['NeueHaasDisplay-Regular'] text-[16px] leading-[19px]",
        customShopImage: "/assets/customizations/hetcomite/shop.png",
        customShopImageStyle: "border border-black",
      },
    },
    announcements: {
      created: "",
      emptyOrLoadingState: "font-bold font-['DanceV2'] text-[20px] leading-[20px] mb-[500px]",
      container: "mb-16 sm:p-11 p-7 sm:space-y-[38px] space-y-[33px]",
      header: "font-bold text-[32px] leading-[32px] font-['DanceV2']",
      title: "font-bold text-[24px] leading-[24px] pb-2 font-['DanceV2']",
      description: "text-[13px] leading-[16px] font-['HelveticaNeue-Regular']",
      media: "!border-0 rounded-[2px]",
    },
    announcement: {
      likeCount: "",
      commentCount: "",
      created: "",
      emptyOrLoadingState: "font-['HelveticaNeue-Medium'] text-[20px] leading-[20px] mb-[500px]",
      container: "sm:p-10 p-7 pb-8 space-y-[23px]",
      title: "font-bold text-[20px] leading-[24px] pb-2 font-['HelveticaNeue-Medium']",
      description: "font-['HelveticaNeue-Regular'] text-[13px] sm:w-[557px]",
      commentIconColor: "",
      likeIconColor: "",
    },
    events: {
      sectionHeader: "uppercase font-['DanceV2']",
      media: "!border-0 rounded-[2px]",
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "text-[32px] leading-[32px] font-['DanceV2']",
      title: "font-bold text-[20px] leading-[20px] font-['DanceV2'] my-4",
      emptyOrLoadingState: "font-['HelveticaNeue-Medium'] text-[20px] leading-[20px] my-8",
      duration: "text-[13px] leading-[13px] font-['HelveticaNeue-Medium'] mb-4",
      address: "text-[12px] leading-[12px] font-['HelveticaNeue-Regular'] uppercase",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-black",
    },
    event: {
      media: "border border-black",
      blockContainer: "flex flex-col gap-3",
      container: "flex flex-col sm:p-11 p-6",
      emptyOrLoadingState:
        "font-['NeueHaasDisplay-Medium'] text-[20px] leading-[20px] mt-8 mb-[500px]",
      header:
        "sm:text-[32px] sm:leading-[32px] mt-2 font-['NeueHaasDisplay-Medium'] text-[40px] leading-[48px] sm:mb-0 mb-5 uppercase",
      sectionTitle: "sm:text-[24px] text-[20px] font-['NeueHaasDisplay-Medium'] uppercase",
      sectionSubtitle:
        "text-[16px] leading-[16px] uppercase font-['NeueHaasDisplay-Medium'] uppercase",
      text: "font-['NeueHaasDisplay-Regular'] text-[16px] leading-[19px]",
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-black",
      map: {
        pin: "",
        border: "mb-2 border border-black",
        pinColor: "#000000",
        strokeColor: "transparent",
      },
    },
    eventTickets: {
      container: "flex flex-col sm:p-11 p-6",
      accessCode: {
        container: "flex justify-between items-center font-['Montserrat'] font-medium mb-8",
        ticketsTitle:
          "sm:text-[24px] text-[20px] font-['NeueHaasDisplay-Medium'] uppercase text-[#000]",
        text: "text-[16px] leading-[16px] uppercase font-['NeueHaasDisplay-Medium'] text-[#000000]",
      },
      event: {
        title:
          "sm:text-[32px] sm:leading-[32px] mt-2 font-['NeueHaasDisplay-Medium'] text-[40px] leading-[48px] sm:mb-0 mb-5 uppercase",
        subtitle: "text-[16px] leading-[16px] uppercase font-['NeueHaasDisplay-Medium']",
        media: "border border-black",
      },
      ticket: {
        counterContainer: "bg-[#000000] rounded-[100px]",
        plusMinusColor: "#FFFFFF",
        media: "border border-black ",
        title:
          "text-[14px] sm:text-[20px] leading-[22px] uppercase font-['NeueHaasDisplay-Medium']",
        description:
          "text-[12px] sm:text-[16px] leading-4 font-['NeueHaasDisplay-Medium'] uppercase",
        text: "text-[12px] leading-[19px] font-['NeueHaasDisplay-Regular'] !normal-case",
        price:
          "text-[14px] sm:text-[22px] leading-[22px] font-['NeueHaasDisplay-Medium'] !border-0",
        status:
          "text-[14px] sm:text-[22px] leading-[22px] font-['NeueHaasDisplay-Medium'] !border-0 !normal-case !px-0",
        quantity:
          "text-[14px] sm:text-[18px] leading-[18px] text-[#FFFFFF] font-['NeueHaasDisplay-Regular'] !border-0",
      },
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-black",
    },
  },
}

export default hetcomite
